



























































































































import Component from 'vue-class-component';
import Vue from 'vue';
import * as ent from '@/entities';
import { MasterPageCriteria } from '@/components/base/master/master-page-criteria';

import siteTypesApi from '@/api/site-types.api';
import sitesApi from '@/api/sites.api';
import { mapGetters } from 'vuex';
import * as types from '@/store/types';

@Component({
    computed: mapGetters({
        superadminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS
    })
})
export default class SiteTypesMaster extends MasterPageCriteria {
    public useApproveSale : boolean = false;
    public items: ent.ISiteTypeListModel[] = [];

    protected defaultSort: ent.ISort = {
        field: 'typename',
        asc: true
    };

    get siteId(): number {
        return Number.parseInt(this.$route.params.siteId, 10);
    }

    public async created() {
        const site = await sitesApi.get(this.siteId);
        this.useApproveSale = site.useApproveSale;
        this.search();
    }
    public async list(
        body: ent.ISearchBody
    ): Promise<ent.IPaging<ent.ISiteTypeListModel>> {
        const items = await siteTypesApi.list(this.siteId, {
            sortField: body.sortField,
            sortAsc: body.sortAsc
        });
        return ent.withPaging(items);
    }
}
